<template>
  <div class="logo-intro-wrapper">
    <div class="logo-intro-title">
      {{ config.title }}
    </div>
    <div class="logo-intro-desc">
      <p v-for="(item,index) in config.desc" :key="`logo-intro-${index}`">
        {{ item }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
    }
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.logo-intro-wrapper {
  position: relative;
  margin: 0 auto;
  padding: 64px 48px 120px 337px;
  width: 1240px;
  height: 510px;

  &::before {
    position: absolute;
    top: 75px;
    left: 47px;
    width: 400px;
    height: 594px;
    content: '';
    background-image: url('~assets/images/about-us/hk-logo-intro.png');
    background-size: 210px 305px;
    background-repeat: no-repeat;
  }

  .logo-intro-title {
    margin-bottom: 50px;
    font-size: 48px;
    font-weight: 600;
    color: var(--txt-color-lv1);
    line-height: 56px;
  }

  .logo-intro-desc {
    >p {
      margin-bottom: 24px;
      font-size: 18px;
      font-weight: 500;
      color: var(--txt-color-lv1);
      line-height: 24px;
    }

    & :last-child {
      margin-bottom: 0;
    }
  }
}
</style>
